export default "__VITE_ASSET__xlmbU1NtSFLrwBshE2JTng__"